import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { nl } from "./nl";
import { en } from "./en";

const resources = {
  en: {
    translation: en,
  },
  nl: {
    translation: nl,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "nl",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
